import { Button } from "@/components/ui/button";
import { getFileUrl } from "@/lib/file.util";
import { Opportunity } from "@/lib/types/opportunity";
import { MapPin, Calendar } from "lucide-react";
import Link from "next/link";

interface OpportunityCardProps {
  opportunity: Opportunity;
  index: number;
}

export default function OpportunityCard({ opportunity, index }: OpportunityCardProps) {
  const formatDate = (date: string | Date | object) => {
    if (typeof date === 'string') {
      return new Date(date).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric'
      });
    } else if (date instanceof Date) {
      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric'
      });
    }
    return 'Date not available';
  };

  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300">
      <div className="aspect-video overflow-hidden">
        <img
          src={getFileUrl(opportunity.thumbnail) || "/placeholder.svg"}
          alt={opportunity.title}
          className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
        />
      </div>
      
      <div className="p-6">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-1 text-green-600">
            <MapPin className="h-4 w-4" />
            <span className="text-sm font-medium">{opportunity.location}</span>
          </div>
          <div className="flex items-center gap-1 text-gray-500">
            <Calendar className="h-4 w-4" />
            <span className="text-sm">{formatDate(opportunity.date)}</span>
          </div>
        </div>
        
        <h3 className="text-xl font-semibold text-gray-900 mb-3 line-clamp-2">
          {opportunity.title}
        </h3>
        
        <p className="text-gray-600 mb-4 line-clamp-3">
          {opportunity.description}
        </p>
        
        <Button asChild className="w-full">
          <Link href={`/opportunities/${opportunity.id}`}>
            View Details
          </Link>
        </Button>
      </div>
    </div>
  );
} 